<template>
    <div class="card" style="margin-bottom:10px">
        <div class=" card-body">

            <div class="modal-header d-flex justify-content-center rounded mb-1"
                style="background-color: #0078be; padding: 10px;">
                <h6 class="modal-title text-center" style="color: white; margin: 0;">Escoja Cie10</h6>
            </div>

            <div class="col-12 mb-3">
                <input placeholder="Ingrese el nombre" class="form-control col-lg-12" type="text" autocomplete="off"
                    v-model="cie10.searchTerm" @input="toUppercase" />
            </div>

            <DataTable :columns="columns" :options="options" :data="transactions" class="table tablesorter" width="100%"
                @click="agregarCie10">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Código</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in transactions" :key="item.Codigo" :data-index="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.Codigo }}</td>
                        <td>{{ item.Descripcion }}</td>
                    </tr>
                </tbody>
            </DataTable>


        </div>
    </div>
</template>


<script>
/* eslint-disable */

import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
import $ from 'jquery';

DataTable.use(DataTablesCore);

export default {
    name: "Carga-Cie10",
    components: {
        DataTable
    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            transactions: [],
            cie10: {
                searchTerm: ''
            },
            cie10Seleccionados: [],
            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                { data: 'Codigo' },
                { data: 'Descriptor' }
            ],
            options: {
                info: false,
                searching: false,
                responsive: true,
                lengthChange: false,
                ordering: false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ],
                pageLength: 8,
                language: {
                    search: "Buscar:",
                    zeroRecords: "Lo sentimos, no se encontraron resultados",
                    processing: "Buscando. Espere por favor..."
                }
            }

        };
    },
    computed: {},
    watch: {
        'cie10.searchTerm': {
            handler() {
                //const regex = /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]+$/; //Letras y espacios
                //let filteredName = newVal.split('').filter(char => regex.test(char)).join('');
                this.cie10.searchTerm = this.cie10.searchTerm.toUpperCase();
                this.debouncedGetLista();
            },
            immediate: false // No se ejecuta inmediatamente al cargar la página
        }
    },

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.loadCie10All();

    },
    methods: {
        agregarCie10(event) {
            const rowElement = event.target.closest("tr");
            if (!rowElement) return;

            const dataIndex = rowElement.dataset.index;
            const rowIndex = dataIndex !== undefined ? parseInt(dataIndex) : this.getActualDataIndex(rowElement);

            if (rowIndex < 0 || !this.transactions[rowIndex]) return;

            const item = this.transactions[rowIndex];

            // Verificar si ya existe en los seleccionados
            if (!this.cie10Seleccionados.some(cie => cie.Codigo === item.Codigo)) {
                const nuevoItem = {
                    Codigo: item.Codigo,
                    Descriptor: item.Descriptor, // Asegúrate que coincida con lo que espera el otro componente
                    tipo: '',
                    descripcion: '',
                    errorPresuntivo: false,
                    errorDefinitivo: false
                };

                // Emitir el evento con el nombre correcto y la estructura esperada
                this.$emit('datos-seleccionados-cie10', nuevoItem);
            }
        },

        // Método auxiliar para encontrar el índice real en los datos
        getActualDataIndex(rowElement) {
            const codigo = rowElement.cells[1].textContent; // Asumiendo que la columna 1 es el código
            return this.transactions.findIndex(item => item.Codigo === codigo);
        },

        loadCie10All() {
            this.$https.post('/codigos/getLoadCie10All', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.transactions = response.data.data;
                } else {
                    this.transactions = [];
                }
            }).catch(() => {
                this.$toast.error("Ocurrió un error inesperado", { position: "top-right" });
            });
        },

        loadCie10() {
            this.$https.post('/codigos/getloadCie10Search', { busqueda: this.cie10.searchTerm }, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.transactions = response.data.datos;
                } else {
                    this.transactions = [];
                }
            }).catch(error => {
                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }

                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                }
                throw error; // Relanza el error para manejarlo en el componente
            });
        },

        debouncedGetLista: debounce(function () {
            if (this.cie10.searchTerm.length === 0) {
                // Si el input está vacío, llamar a getListaAll
                this.loadCie10All();
            } else if (this.cie10.searchTerm.length >= 3) {
                // Solo realizar la búsqueda si hay al menos 3 caracteres
                this.loadCie10();
            }
        }, 1000), // 3000 ms = 3 segundos
    }

}

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

</script>


<style scoped>
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';

/* Agregar cursor pointer a las filas de la tabla */
::v-deep .table tbody tr {
    cursor: pointer;
}

/* Efecto hover en las filas */
::v-deep .table tbody tr:hover {
    background-color: #f5f5f5;
}
</style>
